const zeroIfNull = (x) => {
    if (isNaN(x)) {
      return 0;
    }
    return x;
  };

export const cleanedBarData = (apiResponse) => {
    const staff = apiResponse.data[0].report.staff;
    const yellow = [];
    const blue = [];
    const gray = [];
    const orange = [];
    const categories = [];
    for (let name in staff) {
      let staff_name = staff[name];
      let total = zeroIfNull(
        Math.round(
          (staff_name["total"]["budgeted"] - staff_name["total"]["actual"]) * 10
        ) / 10
      );
      let assigned = zeroIfNull(
        Math.round(
          (staff_name["Assigned"]["budget"] -
            staff_name["Assigned"]["actual"]) *
            10
        ) / 10
      );
      let extension = zeroIfNull(
        Math.round(
          (staff_name["Extension"]["budget"] -
            staff_name["Extension"]["actual"]) *
            10
        ) / 10
      );
      let not_ready = zeroIfNull(
        Math.round(
          (staff_name["Not Ready for Prep"]["budget"] -
            staff_name["Not Ready for Prep"]["actual"]) *
            10
        ) / 10
      );
      // W/o color and w/o subcategories data
      if (total == 0 && assigned == 0 && extension == 0 && not_ready == 0) {
        continue;
      }
      yellow.push(total);
      blue.push(assigned);
      gray.push(extension);
      orange.push(not_ready);
      categories.push(name);
    }

    const barChartData = [
      { data: yellow, name: "Total", color: "#ff793f" },
      { data: blue, name: "Assigned", color: "#34ace0" },
      { data: gray, name: "Extension", color: "#706fd3" },
      { data: orange, name: "Not ready for prep", color: "#ffda79" },
    ];
    return [categories, barChartData];
  };

export const defaultBarData = (result) => {
    const staff = result.data[0].report.staff;
    const yellow = [];
    const blue = [];
    const gray = [];
    const orange = [];
    const categories = [];
    for (let name in staff) {
      let staff_name = staff[name];
      let total = zeroIfNull(
        Math.round(
          (staff_name["total"]["budgeted"] - staff_name["total"]["actual"]) * 10
        ) / 10
      );
      let assigned = zeroIfNull(
        Math.round(
          (staff_name["Assigned"]["budget"] -
            staff_name["Assigned"]["actual"]) *
            10
        ) / 10
      );
      let extension = zeroIfNull(
        Math.round(
          (staff_name["Extension"]["budget"] -
            staff_name["Extension"]["actual"]) *
            10
        ) / 10
      );
      let not_ready = zeroIfNull(
        Math.round(
          (staff_name["Not Ready for Prep"]["budget"] -
            staff_name["Not Ready for Prep"]["actual"]) *
            10
        ) / 10
      );
      yellow.push(total);
      blue.push(assigned);
      gray.push(extension);
      orange.push(not_ready);
      categories.push(name);
    }

    const barChartData = [
      { data: yellow, name: "Total", color: "#ff793f" },
      { data: blue, name: "Assigned", color: "#34ace0" },
      { data: gray, name: "Extension", color: "#706fd3" },
      { data: orange, name: "Not ready for prep", color: "#ffda79" },
    ];
    return [categories, barChartData];
  };

  export  const setPrimaryBarData = (result) => {
    const staff = result.data[0].report.staff;
    const hours = result.data[0].report.hours_remaining_in_busy_season;
    const recentDate = result.data[0].report.most_recent_report_date;
    const grid_data = [];
    for (let name in staff) {
      const data = {
        name: name,
        role: staff[name].role,
        title: staff[name].title,
        experience: staff[name].experience,
        "budget ": staff[name]["Assigned"].budget,
        "actual ": staff[name]["Assigned"].actual,
        "budget  ": staff[name]["Extension"].budget,
        "actual  ": staff[name]["Extension"].actual,
        "budget   ": staff[name]["N/A"].budget,
        "actual   ": staff[name]["N/A"].actual,
        "budget    ": staff[name]["Not Ready for Prep"].budget,
        "actual    ": staff[name]["Not Ready for Prep"].actual,
        "budget     ": staff[name]["total"].budgeted,
        "actual     ": staff[name]["total"].actual,
      };
      grid_data.push(data);
    }
    return [hours, recentDate, grid_data];
  };
